/* tslint:disable */
/* eslint-disable */
/**
 * channels-com
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface UserLogin
 */
export interface UserLogin {
  /**
   *
   * @type {string}
   * @memberof UserLogin
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof UserLogin
   */
  password: string;
}

export function UserLoginFromJSON(json: any): UserLogin {
  return UserLoginFromJSONTyped(json, false);
}

export function UserLoginFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserLogin {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    email: json['email'],
    password: json['password'],
  };
}

export function UserLoginToJSON(value?: UserLogin | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    email: value.email,
    password: value.password,
  };
}
